import { Schema } from "effect";
import { StationRevision } from "@workerstation/shared/station/http";

// Rail members keep the string identities used by the shared HTTP contract.
export const SessionMembers = Schema.Struct({
  workspaces: Schema.Array(Schema.String),
  active: Schema.String
});
export type SessionMembers = typeof SessionMembers.Type;
export const CurrentSession = Schema.Struct({
  ...SessionMembers.fields,
  updatedAt: StationRevision
});
export type CurrentSession = typeof CurrentSession.Type;
export const SessionCandidate = Schema.Struct({
  workspaces: Schema.Array(Schema.String),
  active: Schema.optionalKey(Schema.String),
  updatedAt: StationRevision
});
export const sessionPersistenceKey = (stationId: string): string => JSON.stringify(["session", stationId]);
